import {defineStore} from 'pinia'
import {CommonNs, type SignUpNs, TokenNs} from "@shared/types";
import {SignInApi, TokenApi} from "@/api";
import {cookies, getBaseDomain, websocket} from "@shared/helpers";
import {v4 as uuidv4} from 'uuid'
import {useResetStores} from "@shared/composables/use-reset-stores";


export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: {} as TokenNs.TokenData,
    publicToken: {} as TokenNs.TokenData
  }),
  getters: {
    getToken: (state): TokenNs.TokenData => state.token,
    getPublicToken: (state): TokenNs.TokenData => state.publicToken
  },
  actions: {
    setToken(tokenData: TokenNs.CreateTokenResponse): TokenNs.TokenData {
      const token = {
        accessToken: tokenData.access_token,
        refreshToken: tokenData.refresh_token,
        tokenType: tokenData.token_type
      }
      this.token = token

      cookies.set('meta-token', JSON.stringify(token), {domain: getBaseDomain})
      return token
    },

    async createToken(
        payload: TokenNs.CreateTokenRequest
    ): Promise<TokenNs.TokenData | Error> {
      const clientInstanceId = uuidv4();
      return TokenApi.createToken(payload, clientInstanceId)
      .then((tokenData) => {
        return this.setToken(tokenData);
      });
    },

    async createPublicToken(
        payload: TokenNs.CreateTokenRequest
    ): Promise<TokenNs.TokenData | Error> {
      const clientInstanceId = uuidv4();
      return TokenApi.createToken(payload, clientInstanceId)
      .then((tokenData) => {
        return this.setToken(tokenData);
      });
    },

    logout(): void {
      websocket.disconnect();
      useResetStores().resetAll();
      cookies.remove('meta-token', {domain: getBaseDomain});
      cookies.remove('meta-workspace', {domain: getBaseDomain});
    },

    async resetPassword(
        payload: SignUpNs.ResetPasswordRequest
    ): Promise<SignUpNs.ResetPasswordResponse> {
      return SignInApi.resetPassword(payload).then((data) => data)
    },

    async createNewPassword(
        payload: SignUpNs.CreatePasswordRequest
    ): Promise<CommonNs.GenericResponse> {
      return SignInApi.createNewPassword(payload).then((data) => data)
    }
  }

})
